import { motion, useAnimation } from "framer-motion";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";

import projects from "../../data/projects";

const ProjectCard = ({ project, index }) => {
  // const { ref, inView } = useInView({
  //   threshold: 0.2,
  // });

  // const animation = useAnimation();

  // useEffect(() => {
  //   if (inView) {
  //     animation.start({
  //       x: 0,
  //       transition: {
  //         type: "spring",
  //         duration: 1,
  //         bounce: 0.2,
  //       },
  //     });
  //   } else {
  //     animation.start({
  //       x: index % 2 === 0 ? "-100vw" : "100vw",
  //     });
  //   }
  // }, [inView, animation, index]);

  return (
    <div className="section--spacing-x my-10 grid grid-cols-1 gap-y-1 md:grid-cols-3 md:gap-2">
      {/* Project Information */}
      <div className="flex flex-col items-start justify-center bg-stone-200 p-4 lg:p-10">
        <Link to={`/project/${project.slug}`}>
          <h4 className="sub--title">{project.developer}</h4>

          <h2 className="project--title">{project.title}</h2>
        </Link>

        <h4 className="sub--title">{project.location}</h4>
      </div>

      {/* Project Image */}
      <div className="group relative col-span-2 cursor-pointer font-poiret">
        <Link to={`/project/${project.slug}`}>
          <img
            className="aspect-21/9 w-full object-cover"
            src={project.thumb}
            alt={project.title}
          />

          <div className="bg-blur absolute left-0 top-0 hidden h-0 w-full flex-col items-center justify-center border-b-2 opacity-0 backdrop-blur-md duration-500 group-hover:h-[50%] group-hover:opacity-100 dark:bg-slate-500 sm:flex">
            <h2 className="project--title-btn">{project.title}</h2>

            <span className="mt-5 rounded-full bg-white px-8 py-3 duration-300 hover:bg-stone-300 dark:bg-slate-600 dark:text-slate-200 dark:hover:bg-slate-700">
              Project Details
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
};

const Projects = () => {
  return (
    <motion.div
      className="dark:bg-slate-600"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.3,
        },
      }}
    >
      {/* Hero */}
      <div className="group relative">
        <img
          className="h-64 w-full object-cover grayscale lg:h-[550px]"
          src={projects[0]?.cover}
          alt="Projects"
        />

        <div className="tracking-in-expand section--spacing-x hero--text-inner backdrop-blur-sm">
          <p className="tracking-in-expand heading--xxxl">Projects</p>
        </div>
      </div>

      {/* Projects */}
      <div className="mt-32">
        {projects.map((project, index) => (
          <ProjectCard key={project.slug} project={project} index={index} />
        ))}
      </div>
    </motion.div>
  );
};

export default Projects;
